import type { CosmicProductType } from '@/lib/cms/cosmic/types/CosmicProductType'
import type { GlobalStoreValues } from '@/store/useGlobalStore'
import { getTerms } from '../../services/useGetTerms'

type Props = {
  globalStore: GlobalStoreValues
  product: CosmicProductType
}

export const getEcommerceObjectFromProduct = ({
  globalStore,
  product,
}: Props) => {
  const {
    user: { customerType },
    app: { marketExceptions },
  } = globalStore

  const getProductFirstCategory = () => {
    if (!product.categories) return null
    if (product.categories.length === 0) return null

    return product.categories?.[0].seo?.page.title
  }

  // Its called because the return is an array, expected by GTM
  // But it should only ever return one item
  const getItems = () => ({
    item_brand: 'Unicity',
    discount: product.subscriptionDiscount,
    item_id: product.variations[0].sku,
    item_category: getProductFirstCategory(),
    ship_by: undefined, // TODO: Figure out a way to get the ship by in the cart
    item_name: product.name,
    purchase_type: 'subscription', // https://app.clickup.com/t/55477/ECOM-2485?comment=90170060503701
    price: getTerms({
      forCustomerType: customerType,
      pricingData: product.variations[0].pricing,
    })?.priceEach,
    quantity: 1,
  })

  return {
    currency: marketExceptions?.currencyCode,
    value: getTerms({
      forCustomerType: customerType,
      pricingData: product.variations[0].pricing,
    })?.priceEach,
    items: [getItems()],
  }
}
